const multiUserMixin = {
  computed: {
    hasMultipleAccounts () {
      return Object.keys(this.$store.state.multiUsers.users).length > 1
    }
  }
}

export default multiUserMixin
